import axios from "axios";
//import { Toast } from "./notifications";

// const baseURL = "http://localhost:8080/rocon";
const baseURL = process.env.REACT_APP_BACK_END_API_BASE_URL;

if (process.env.REACT_APP_TEMP_DOMAIN === "roconpaas.io") {
  // console.log("Base URL is ", baseURL);
} else {
  console.log("Base URL is ", baseURL);
}

/**
 * @description axios instance for ajax requests
 */

let client = axios.create({
  baseURL: baseURL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    Authorization: "Bearer " + localStorage.getItem("accessToken"),
  },
});

client.interceptors.request.use(
  (config) => {
    config.headers.Authorization =
      "Bearer " + localStorage.getItem("accessToken");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/**
  * @description if any of the API gets 401 status code, this method 
   calls getAuthToken method to renew accessToken
  * updates the error configuration and retries all failed requests 
  again
*/

client.interceptors.response.use(undefined, (err) => {
  const error = err.response;
  // if error is 401
  if (
    error?.status === 401 &&
    error?.config &&
    !error?.config.__isRetryRequest
  ) {
    // update the error config with new token
    error.config.__isRetryRequest = true;
    error.config.headers.Authorization =
      "Bearer " + localStorage.getItem("accessToken");
    return client(error.config);
  } else {
    return err;
  }
});

/**
 * @description wrapper for making ajax requests
 * @param {object} object with method,url,data etc.
 */

const request = function (options) {
  const onSuccess = function (response) {
    return response.data;
  };
  const onError = function (error) {
    //console.error('Request Failed:', error.config);
    if (error.response) {
      //console.error('Status:',  error.response.status);
      //console.error('Data:',    error.response.data);
      //console.error('Headers:', error.response.headers);
    } else {
      //Toast("Error!!", "Something went wrong, Please try again", "danger");
    }
    return Promise.reject(error.response || error.message);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;

export async function apiRequest(options) {
  const result = await client(options);

  if (result.status === 401 || result.response?.status === 401) {
    window.location.reload();
  }

  const statusCode = result.status || result.response?.status;

  if (
    statusCode === 200 ||
    statusCode === 201 ||
    statusCode === 202 ||
    statusCode === 504
  ) {
    return { isApiSuccessful: true, ...result };
  } else {
    return { isApiSuccessful: false, ...result };
  }
}
